// extracted by mini-css-extract-plugin
export default {"cabecalho":"Menu_cabecalho__6ceKK","cabecalho__container":"Menu_cabecalho__container__guFrs","cabecalho__input":"Menu_cabecalho__input__BA6WL","menu":"Menu_menu__VoYiJ"};